import { render } from "./StaffDetail.vue?vue&type=template&id=234184b8&ts=true"
import script from "./StaffDetail.vue?vue&type=script&lang=ts"
export * from "./StaffDetail.vue?vue&type=script&lang=ts"

import "./StaffDetail.vue?vue&type=style&index=0&id=234184b8&lang=scss"
import "./StaffDetail.vue?vue&type=style&index=1&id=234184b8&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__